// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"4564fec5","703":"705ee4f5"}[chunkId] + ".chunk.js";
};